import { Row, Col } from "react-bootstrap";
import { IAddDocumentDescriptionProps } from "./AddDocumentInterfaces";
import "./css/Description.css";

export default function AddDocumentDescription({
  addDocumentState,
}: IAddDocumentDescriptionProps) {
  return (
    <div className={"grey-container"}>
      <Row>
        <Col xs={2}>
          {addDocumentState.isProductCompany
            ? "Product Company :"
            : "External Company :"}
        </Col>
        <Col>
          <label>{addDocumentState.selectedCompany?.key}</label>
        </Col>
      </Row>
      <Row>
        <Col xs={2}>
          {addDocumentState.selectedProductRange !== null && (
            <label>Product Range :</label>
          )}
        </Col>
        <Col>
          {addDocumentState.selectedProductRange !== null && (
            <label>{addDocumentState.selectedProductRange}</label>
          )}
        </Col>
      </Row>
      <Row>
        <Col xs={2}>
          {addDocumentState.selectedModels &&
            addDocumentState.selectedModels[0].key && <label>Model :</label>}
        </Col>
        <Col>
          {addDocumentState.selectedModels &&
          addDocumentState.selectedModels[0].key ? (
            <label>
              <label key={addDocumentState.selectedModels[0].key}>
                {addDocumentState.selectedModels[0].key}
              </label>
              {addDocumentState.selectedModels
                .slice(1)
                .map((model: { key: string; label: string }) => (
                  <label key={model.key}>, {model.key}</label>
                ))}
            </label>
          ) : (
            <></>
          )}
        </Col>
      </Row>
      <Row>
        <Col xs={2}>
          {addDocumentState.productNumbers &&
            addDocumentState.productNumbers[0] && (
              <label>Product Number :</label>
            )}
        </Col>
        <Col>
          {addDocumentState.productNumbers &&
          addDocumentState.productNumbers[0] ? (
            <label>
              <label key={addDocumentState.productNumbers[0]}>
                {addDocumentState.productNumbers[0]}
              </label>
              {addDocumentState.productNumbers.slice(1).map((productNumber) => (
                <label>, {productNumber}</label>
              ))}
            </label>
          ) : (
            <></>
          )}
        </Col>
      </Row>
      <Row>
        <Col xs={2}>
          {addDocumentState.serialNumber && <label>Serial Number :</label>}
        </Col>
        <Col>
          {addDocumentState.serialNumber && (
            <label>{addDocumentState.serialNumber}</label>
          )}
        </Col>
      </Row>
    </div>
  );
}
